export default __webpack_public_path__ + "static/media/section23.e8bde88c.svg";